import styles from '../styles/components/bottomModal.module.css';


interface ComponentProps {
    children: React.ReactNode;
    cancel: Function;
};


export default function BottomModal({children, cancel}: ComponentProps) {
    return <>
        <div className={styles.bg} onClick={() => cancel()}/>
        <div className={styles.body}>
            <div className={styles.line}/>
            {children}
        </div>
    </>;
};